module.exports = __webpack_public_path__ + "img/CoinBankSet.38d27b35.jpg";